import React, { useEffect, useState } from "react";
import "../css/wb_session_recieved_report.css";
import Export from "../Assets/images/export.png";
import Search from "../Assets/images/search.png";
import { apiCall } from "../services/authServieces";
import SearchIcon from "@mui/icons-material/Search";
import CustomDateRangePicker from "../components/CustomDatePicker";
import excelIcon from "../Assets/images/excel.png";
import { useUIContext } from "../context";
import { formatDate } from "../utils/helper";
import { FaImage, FaVideo, FaFilePdf } from "react-icons/fa";
import { ClipLoader } from "react-spinners";
import baseURL from "../config";
import axios from "axios";

const WbSessionRecievedReport = () => {
  const [loading, setLoading] = useState(false);
  const [sessionData, getSessionData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [mobilesrch, setmobilesrch] = useState('');
  const [showPagi, setshowPagi] = useState(false);
  const [previewSrc, setPreviewSrc] = useState(null);
  const [previewType, setPreviewType] = useState(null)
  const { dateRanges } = useUIContext();
  const itemsPerPage = 10;

  const fetchData = async (page) => {
    setLoading(true)
    try {
      const dates = dateRanges?.two?.map(date => {
        const localDate = new Date(date);
        const year = localDate.getFullYear();
        const month = String(localDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JS
        const day = String(localDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`; // Format as YYYY-MM-DD
      });
      const params = new URLSearchParams({
        mobileno: mobilesrch || undefined,
        fromDate: dates[0] || undefined,
        toDate: dates[1] || undefined,
        page: page,
        limit: itemsPerPage,
      });

      const res = await apiCall({
        endpoint: `report/getSessionReportData?${params.toString()}`,
        method: "GET",
      });

      const transformedData = res.data.map(item => ({
        date: `${formatDate(item.send_date)} ${item.send_time}`,
        number: item.sender_mobile,
        label: item.sender_profile_name,
        message: item.in_msg ? item.in_msg : '',
        msg_type: item.msg_type ? item.msg_type : '',
        text: item.out_msg ? item.out_msg : ''
      }));


      getSessionData(transformedData);
      setTotalPages(Math.ceil(res.total / itemsPerPage));
      setshowPagi(res.total > itemsPerPage);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    finally {
      setLoading(false);
    }
  };

  // Use useEffect only for the initial render
  useEffect(() => {
    fetchData(currentPage);
  }, []); // Empty dependency array means this will only run once when the component mounts

  const handlePageChange = (page) => {
    setCurrentPage(page); // Update current page
    fetchData(page); // Fetch data for the new page
  };

  const handleSearch = () => {
    setCurrentPage(1); // Reset to the first page on search
    fetchData(1); // Fetch data for the first page
  };

  const createPagination = () => {
    const pagesToShow = 1; // Number of pages to show around the current page
    let pages = [];

    if (totalPages > 1) {
      pages.push(1); // Always show the first page

      if (currentPage > pagesToShow + 2) {
        pages.push(null); // Add ellipsis if needed
      }

      for (
        let i = Math.max(2, currentPage - pagesToShow);
        i <= Math.min(totalPages - 1, currentPage + pagesToShow);
        i++
      ) {
        pages.push(i);
      }

      if (currentPage < totalPages - pagesToShow - 1) {
        pages.push(null); // Add ellipsis if needed
      }

      if (totalPages > 1) {
        pages.push(totalPages); // Always show the last page
      }
    }

    return pages;
  };

  // const handleExport = () => {
  //   const headers = ['S_No.', 'Date', 'Mobile', 'In Message', 'Out Message'];
  //   const csvRows = [];

  //   // Add headers
  //   csvRows.push(headers.join(','));

  //   // Add data
  //   sessionData.forEach((item, index) => {
  //     const row = [
  //       (currentPage - 1) * itemsPerPage + index + 1,
  //       item.date,
  //       item.number,

  //       `"${item.message.replace(/"/g, '""').replace(/\n/g, ' ')}"`, // Replace newlines with spaces
  //       item.text,
  //     ];

  //     csvRows.push(row.join(','));
  //   });

  //   // Create CSV string
  //   const csvString = csvRows.join('\n');

  //   // Create a blob and download the CSV
  //   const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  //   const link = document.createElement('a');
  //   const url = URL.createObjectURL(blob);
  //   link.setAttribute('href', url);
  //   link.setAttribute('download', 'session_report.csv');
  //   link.style.visibility = 'hidden';
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };


  // Function to handle preview click logic
 
    const handleExport = async () => {
    setLoading(true);
    try {
      const dates = dateRanges?.two?.map(date => {
        const localDate = new Date(date);
        const year = localDate.getFullYear();
        const month = String(localDate.getMonth() + 1).padStart(2, '0');
        const day = String(localDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      });
  
      // Build the query parameters
      const params = new URLSearchParams();
      if (mobilesrch) params.append('mobileno', mobilesrch);
      if (dates?.[0]) params.append('fromDate', dates[0]);
      if (dates?.[1]) params.append('toDate', dates[1]);
  
      const user = JSON.parse(localStorage.getItem("user-cred"));
      
      // Using the same approach as your working downloadExcelDashboard function
      const baseUrl =baseURL  ||  'http://localhost:8000'; // Make sure baseURL is defined
      const endpoint = `report/exportSessionReport?${params.toString()}`;
      const url = `${baseUrl}/${endpoint}`;
  
      const response = await axios.get(url, {
        responseType: 'blob',
        headers: {
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'Authorization': `Bearer ${user?.token}`
        }
      });
  
      // Check for empty file
      if (response.data.size === 0) {
        throw new Error('Received empty file');
      }
  
      // Generate filename
      let filename = 'session_report';
      if (dates?.[0] && dates?.[1]) {
        filename = `session_report_${dates[0]}_to_${dates[1]}`;
      }
  
      // Try to get filename from Content-Disposition header, if available
      const contentDisposition = response.headers['content-disposition'];
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch && filenameMatch[1]) {
          filename = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ''));
        } else {
          filename = `${filename}.xlsx`;
        }
      } else {
        filename = `${filename}.xlsx`;
      }
  
      // Create download link with the filename
      const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = downloadUrl;
      link.download = filename;
  
      // Append to document, click, and cleanup
      document.body.appendChild(link);
      link.click();
  
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
       ;
      }, 100);
    } catch (error) {
      console.error("Error exporting data:", error);
    
    } finally {
      setLoading(false);
    }
  };
 
  const handlePreviewClick = (src, type) => {
    setPreviewSrc((prevSrc) => (prevSrc === src ? null : src));
    setPreviewType((prevType) => (prevType === type ? null : type));
  };



  return (
    <>
      {loading && (
        <div className="spinnerOverlay">
          <ClipLoader loading={loading} size={50} />
        </div>
      )}
      <div className="Session_report_contian">
        <h4 className="Head_title MisReportTitle">
          <div className="DateRangeContain"><CustomDateRangePicker rangeKey="two" /><button type="button" className="SearchDateRange" onClick={handleSearch}><img src={Search} alt="Search" /></button></div>
          Session Report
          <div className="SessionExcelContain">
            <div className="Session_report_SearchContain">
              <input
                type="text"
                value={mobilesrch}
                onChange={(e) => setmobilesrch(e.target.value)}
                placeholder="Search"
              />
              <button type="button" onClick={handleSearch}>
                {/* Search */}
                <SearchIcon />
              </button>
            </div>

            <button type="button" className="ExcelIconContain" onClick={handleExport}>
              <img src={excelIcon} alt="excelIcon" className="ExcelIcon" />
            </button>
          </div>
        </h4>
        <div className="Session_report_Card12">
          {/* <div className="Date_contain gy-2">
          <div className="form_group9">
            <label htmlFor="from_date">From Date</label>
            <input
              type="date"
              id="from_date"
              className="datepicker"
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>
          <div className="form_group9">
            <label htmlFor="to_date">To Date</label>
            <input
              type="date"
              id="to_date"
              className="datepicker"
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
          <div className="form_group9">
            <button type="button" onClick={handleSearch}>
              <img src={Search} alt="img" /> Submit
            </button>
          </div>
          <div className="form_group9">
            <button type="button" className="export_btn" onClick={handleExport}>
              <img src={Export} alt="img" /> Export
            </button>
          </div>
        </div> */}
          <div className="table_contain tableSessionR">
            <table className="Table" id="Table">
              <thead>
                <tr>
                  {/* <th>S_No.</th> */}
                  <th>Date</th>
                  <th>Mobile</th>
                  <th>In Message</th>
                  <th>Out Message</th>
                </tr>
              </thead>
              <tbody>
                {sessionData.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="tableDataCenterPosition">
                      No data available
                    </td>
                  </tr>
                ) : (
                  sessionData.map((item, index) => (
                    <tr key={index}>
                      <td className="text-nowrap">{item.date}</td>
                      <td>{item.number}</td>

                      <td>
                        <p className="message">
                          {item.msg_type === "image/jpeg" ? (
                            <>
                              {/* <img
          src={item.message}
          alt="Message Image"
          style={{ width: "50px", height: "50px", cursor: "pointer" }}
          onClick={() => handlePreviewClick(item.message, "image")}
        /> */}
                              <FaImage
                                size={24}
                                style={{ marginLeft: "10px", cursor: "pointer", color: "#007bff" }}
                                onClick={() => handlePreviewClick(item.message, "image")}
                                title="View Image"
                              />
                            </>
                          ) : item.msg_type === "video/mp4" ? (
                            <>
                              {/* <video width="50px" height="50px" style={{ cursor: "pointer" }} onClick={() => handlePreviewClick(item.message, "video")}>
          <source src={item.message} type="video/mp4" />
        </video> */}
                              <FaVideo
                                size={24}
                                style={{ marginLeft: "10px", cursor: "pointer", color: "#28a745" }}
                                onClick={() => handlePreviewClick(item.message, "video")}
                                title="View Video"
                              />
                            </>
                          ) : item.msg_type === "application/pdf" ? (
                            <>
                              <FaFilePdf
                                size={24}
                                style={{ cursor: "pointer", color: "red" }}
                                onClick={() => handlePreviewClick(item.message, "application")}
                                title="View PDF"
                              />
                            </>
                          ) : item.msg_type === "TEXT" || item.msg_type === "ACTION" ? (
                            <>
                              <p>{item.message}</p>
                            </>
                          ) : item.msg_type === "REPLY" ?  (
                            <>
                              <p>{item.message}</p>
                            </>
                          ) :
                           (
                            <a href={item.message}>Download the File</a>
                          )}
                        </p>

                        {/* Modal for Preview */}
                        {previewSrc && (
                          <div
                            className="modal_main_container"
                            onClick={() => {
                              setPreviewSrc(null);
                              setPreviewType(null);
                            }}
                          >
                            <div
                              className="modal_bg_div"
                            >
                              <button
                                onClick={() => {
                                  setPreviewSrc(null);
                                  setPreviewType(null);
                                }}
                                className="modal_close_icon"
                              >
                                ✕
                              </button>

                              {/* Render only the selected type */}
                              {previewType === "image" ? (
                                <img
                                  src={previewSrc}
                                  alt="Preview"

                                />
                              ) : previewType === "video" ? (
                                <video controls autoPlay style={{ width: "100%", height: "auto" }}>
                                  <source src={previewSrc} type="video/mp4" />
                                </video>
                              ) : previewType === "application" ? (
                                <iframe
                                  src={previewSrc}

                                >
                                  Your browser does not support PDFs.
                                  <a href={previewSrc}>Download the PDF</a> instead.
                                </iframe>
                              ) : null}
                            </div>
                          </div>
                        )}
                      </td>
                      <td>{item.text.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase())}</td>
                    </tr>
                  ))
                )}

              </tbody>
            </table>
          </div>
        </div>

        {/* Merged Pagination */}
        {showPagi && (
          <div className="pagination">
            {createPagination().map((page, index) => (
              page === null ? (
                <span key={index} className="ellipsis">...</span>
              ) : (
                <button
                  key={index}
                  className={`page-button ${currentPage === page ? 'active' : ''}`}
                  onClick={() => handlePageChange(page)}
                >
                  {page}
                </button>
              )
            ))}
          </div>
        )}
      </div>

    </>

  );
};

export default WbSessionRecievedReport;
